import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_QMAX_GRAPH } from './url-constants';

type QMAXEndpointSpecification = ApiEndpointSpecification;
export const QMAXEndpointSpecification: QMAXEndpointSpecification = {

    url:DEVICE_QMAX_GRAPH,
    method:HttpMethod.POST,
    requestParamsSchemaName: 'QMAXGraphRequestParams',
    requestBodySchemaName: 'QMAXGraphRequestBody',
    okResponseSchemaName: 'QMAXGraphOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2
};

export const invokeQmaxApiData = Helpers.makeApiRequestFn<
Types.QmaxGraphRequestParams,
Types.QmaxGraphRequestBody,
Types.QmaxGraphOkresponse
>(QMAXEndpointSpecification);
